import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { defaultDashboardLiteralId } from '@portal/app/shared/constants/constants';
import { ConfigDashboardService } from '@portal/app/shared/services/config-dashboard.service';
import { SelectionService } from '@portal/app/shared/services/selection.service';

@Injectable({ providedIn: 'root' })
export class ConfigDashboardGuard implements CanActivate {
  constructor(
    private readonly configDashboardService: ConfigDashboardService,
    private readonly selectionService: SelectionService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const literalId = route.data?.['configDashboardLiteralId'] as
      | string
      | undefined;
    if (!literalId) {
      return of(true);
    }
    return from(this.configDashboardService.isDashboardVisible(literalId)).pipe(
      map((visible) => (visible ? true : this.buildFallbackUrl(route)))
    );
  }

  private buildFallbackUrl(route: ActivatedRouteSnapshot): UrlTree {
    const brandSlug =
      route.paramMap.get('brandSlug') ||
      this.selectionService.buildSelectionSlug();
    if (!brandSlug) {
      return this.router.parseUrl('/a/select-brand');
    }
    return this.router.parseUrl(
      `/a/${brandSlug}/products/portfolio/${defaultDashboardLiteralId}`
    );
  }
}
